import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useBasicToast() {
  const toast = useToast()
  const basicToast = ({ title, type }) => {
    let icon = ''
    switch (type) {
      case 'success':
        icon = 'CheckCircleIcon'
        break
      case 'error':
        icon = 'AlertTriangleIcon'
        break
      default:
        icon = 'AlertOctagonIcon'
    }
    return toast({
      component: ToastificationContent,
      props: {
        title,
        icon,
        variant: type,
      },
    })
  }
  return basicToast
}
